import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const newsfeedApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "newsfeedApi",
  tagTypes: ["NewsFeed"],
  endpoints: (builder) => ({
    getNewsFeed: builder.mutation({
      query: (payload) => ({
        url: `newsfeed`,
        method: "POST",
        body: payload,
      }),
    }),
    getNewsFeedComments: builder.mutation({
      query: (payload) => ({
        url: `/newsfeed/comments`,
        method: "POST",
        body: payload,
      }),
    }),
    createNewsFeedComment: builder.mutation({
      query: (payload) => ({
        url: `/newsfeed/comment/create`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const { useGetNewsFeedMutation, useGetNewsFeedCommentsMutation, useCreateNewsFeedCommentMutation } = newsfeedApi
